export const reDistrictConstants = {
	GetList: {
		REQUEST : 'GET_LIST_DISTRICT_REQUEST',
		SUCCESS : 'GET_LIST_DISTRICT_SUCCESS',
		FAILURE : 'GET_LIST_DISTRICT_FAILURE'
	},
	getListActualByRegion: {
		SUCCESS : 'GET_LIST_ACTUAL_BY_REGION_SUCCESS',
		REQUEST : 'GET_LIST_ACTUAL_BY_REGION_REQUEST',
		FAILURE : 'GET_LIST_ACTUAL_BY_REGION_FAILURE'
	},
	CLEAR: 'CLEAR_DISTRICT'
}